import { render, staticRenderFns } from "./createStepSucceed.vue?vue&type=template&id=f22819e2&scoped=true"
import script from "./createStepSucceed.vue?vue&type=script&lang=js"
export * from "./createStepSucceed.vue?vue&type=script&lang=js"
import style0 from "./createStepSucceed.vue?vue&type=style&index=0&id=f22819e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22819e2",
  null
  
)

export default component.exports